import * as types from './actionTypes';  
import bizInsightsListApi from '../api/bizInsightsListApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doFetchBizInsightsList(ext_id) {

  return {
    type: types.DO_FETCH_BIZ_INSIGHTS_LIST, 
    ext_id
  };
}

export function doFetchBizInsightsListRes(data) {  
  return {
    type: types.DO_FETCH_BIZ_INSIGHTS_LIST_RES, 
    data
  };
}

export function getBizInsightsList(ext_id) {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      bizInsightsListApi.doFetchBizInsightsList(ext_id).then(data => {
        dispatch(doFetchBizInsightsListRes(data));
        dispatch(doFetchBizInsightsListRes(null));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
  
}